const horizontalDragScroll = function (slider) {
  let mouseDown = false;
  let wasScrolled = false;
  const SCROLL_VALUE_TO_PREVENT_CLICK = 30;
  let startX, scrollLeft;

  let startDragging = function (e) {
    mouseDown = true;
    wasScrolled = false;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };
  let stopDragging = function (e) {
    mouseDown = false;
    e.stopPropagation();
    e.preventDefault();
    return false;
  };

  let preventClick = function (e) {
    if (wasScrolled) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  }

  slider.addEventListener('mousemove', (e) => {
    e.preventDefault();
    if (!mouseDown) return;
    const x = e.pageX - slider.offsetLeft;
    const scroll = x - startX;
    if (Math.abs(scroll) > SCROLL_VALUE_TO_PREVENT_CLICK) wasScrolled = true;
    slider.scrollLeft = scrollLeft - scroll;
  });

  slider.addEventListener('mousedown', startDragging, false);
  slider.addEventListener('mouseup', stopDragging, false);
  slider.addEventListener('mouseleave', stopDragging, false);
  slider.addEventListener('click', preventClick, false);
}

export {horizontalDragScroll}
